import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../PortraitStage";
import { SuccessTick } from "../icon";

interface SuccessScanModalProps extends ModalProps {
  onHide: () => void;
  message?: string;
}

const SuccessScanModal = ({ message, ...props }: SuccessScanModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>
        <SuccessTick />
        <div className="loaderTxtScan">
          {message || (
            <>
              QR Code Ticket <br /> Successfully verified!
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessScanModal;
